var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-slider',_vm._l((_vm.banner),function(item,index){return _c('swiper-slide',{key:index},[_c('a',{staticClass:"slider-link",attrs:{"href":item.linkUrl}},[_c('img',{staticClass:"slider-img",attrs:{"src":item.picUrl}})])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }